import React from 'react';

function MapView() {
	return(
		<div className="content">
			<h1>Map</h1>
		</div>
	)
}

export default MapView;